import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { catchError } from 'rxjs';
import { errorHandl } from 'src/app/utils/network-utils';
import { urls } from 'src/app/utils/url.utils';

@Injectable({
  providedIn: 'root'
})
export class UserService {

  constructor(
    private http: HttpClient
  ) { }

  // DRIVERS
  saveUser(id:any, payload: any) {
    if (id) {
      return this.http.patch(urls.API_URL + urls.USERS + `/${id}`, payload)
        .pipe(catchError(errorHandl));
    }
    return this.http.post(urls.API_URL + urls.USERS, payload)
      .pipe(catchError(errorHandl));

  }

  getUsers() {
    // id: any, queryParams: any
    // const params = new HttpParams({ fromObject: queryParams });
    return this.http.get(urls.API_URL + urls.USERS)
      .pipe(catchError(errorHandl));
  }

  getUserById(id: any) {
    return this.http.get(urls.API_URL + urls.USERS + `/${id}`)
      .pipe(catchError(errorHandl));
  }
}
